import React, { useEffect, useState } from "react";
import Skeleton from "react-loading-skeleton";

const SkeletonComponent = (props) => {
    const {
        className = '',
        numberOfItems = 1,
        SkeletonClassName = 'skeleton',
        useTimeout = false,
        timeout = 1000,
        actionOnTimeout = () => { },
    } = props;
    const [removeSkeleton, setRemoveSkeleton] = useState(false);

    useEffect(() => {
        let isMounted = true;

        if (useTimeout) {
            const timer = setTimeout(() => {
                actionOnTimeout();
                if (isMounted) setRemoveSkeleton(true);
            }, timeout);

            return () => {
                clearTimeout(timer)
                isMounted = false;
            };
        }

        return () => isMounted = false;
    }, [useTimeout, timeout]);

    return (
        <>
            {!removeSkeleton && <div className={className}>
                {
                    Array(numberOfItems).fill().map((_, index) => (
                        <span key={index}>
                            <Skeleton className={SkeletonClassName} />
                        </span>
                    ))
                }
            </div>}
        </>
    )
}

export default SkeletonComponent;
